import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca951e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }

import { reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserApi from "@/api/UserApi";
import DeptApi from "@/api/DeptApi";
import Dept from "@/mode/Dept";
import { useChatStore } from "@/store/chatStore";
import User from "@/mode/User";
import Avatar from "@/components/Avatar.vue";
import ChatType from "@/config/ChatType";

interface IData {
  user: User | null;
  depts: Array<Dept>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {

const store = useChatStore();
const router = useRouter();
const route = useRoute();

const userId = route.params.id;

const data = reactive<IData>({
  user: null,
  depts: new Array<Dept>(),
});
if (typeof userId === "string") {
  UserApi.getUser(userId).then((res) => {
    data.user = res.data;
    if ("null" === res.data.deptId) {
      return;
    }
    return DeptApi.parent(res.data.deptId).then((res) => {
      res.data.forEach((item: Dept) => {
        data.depts.push(item);
      });
    });
  });
}
const send = () => {
  if (data.user) {
    store.openChat({
      id: data.user.id,
      name: data.user.name,
      avatar: data.user.avatar,
      type: ChatType.FRIEND,
      lastMessage: "",
      unreadCount: 0,
      isLoading: false,
      loaded: true,
    });
    router.push("/index/chat");
  }
};
const { user, depts } = toRefs(data);

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(user))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Avatar, {
            img: _unref(user).avatar,
            size: "large",
            name: _unref(user).name
          }, null, 8, ["img", "name"])
        ]),
        _createVNode(_component_el_descriptions, {
          title: "用户信息",
          class: "description",
          column: 2
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(user).name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "性别" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(user).sex === "0" ? "男" : "女"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "电话" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(user).mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "邮箱" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(user).email), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "部门",
              role: "2"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depts), (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.id
                  }, _toDisplayString(item.name) + ",", 1))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "send-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (send()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("发送消息")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})